import { h } from 'preact'
import PropTypes from 'prop-types'
import Input from '../../../Common/Input'
import { useTranslations } from '../../../../hooks/useTranslations'
import { AUTOCOMPLETE_VALUES } from '../../../../constants/autocompleteValues'
import { CARD_FIELDS } from '../../../../constants/card'

const values = {
  [CARD_FIELDS.email]: AUTOCOMPLETE_VALUES.EMAIL,
  [CARD_FIELDS.directDebitEmail]: AUTOCOMPLETE_VALUES.DIRECT_DEBIT_EMAIL,
  [CARD_FIELDS.walleyEmail]: AUTOCOMPLETE_VALUES.WALLEY_EMAIL,
}

const Email = ({ register, errors, label, type, trigger }) => {
  const l10n = useTranslations()

  const handleKeyPress = async e => {
    if (e.key === 'Enter') {
      e.preventDefault()
      await trigger(type)
    }
  }

  return (
    <Input
      label={label}
      inputProps={{
        'data-apexx': 'email',
        'data-testid': 'email',
        name: 'email',
        id: type,
        autocomplete: values[type],
        onKeyPress: handleKeyPress,
        ...register(type, {
          required: true,
          pattern:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        }),
      }}
      hasError={errors && Boolean(errors[type])}
      errorMessage={l10n.t('Please enter the valid email address')}
    />
  )
}

Email.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
}

export default Email
